<template>
  <div class="panel wraper panel-gray">
    <div class="panel-header">
      <div class="panel-title">{{lbl}}</div>
    </div>
    <div class="panel-body" id="formbody">
      <q-field
        :error="$v.tempHospital.abbr.$error"
        :error-label="$v.tempHospital.abbr | errorLabel"
      >
        <q-input v-model.trim="tempHospital.abbr" :autofocus="true" float-label="Назв.сокр-ное" />
      </q-field>
      <q-field>
        <q-input v-model.trim="tempHospital.fullName" float-label="Название"/>
      </q-field>
      <q-field
        :error="$v.tempHospital.city.$error"
        :error-label="$v.tempHospital.city | errorLabel"
      >
        <q-input v-model.trim="tempHospital.city" float-label="Город">
          <q-autocomplete
            :static-data="{field: 'value', list: cities}"
          />
        </q-input>
      </q-field>
      <q-field>
        <q-input v-model.trim="tempHospital.address" float-label="Адрес" />
      </q-field>
      <q-field>
        <q-input type="textarea" :rows="1"
                 v-model.trim="telString" float-label="Контакты" />
      </q-field>
      <q-field>
        <q-input type="textarea" :rows="1"
                 v-model.trim="tempHospital.comment" float-label="Заметки" />
      </q-field>
    </div>
    <save-btn :notChanged="notChanged" :goView="goView" :doSave="doSave" />
  </div>
</template>

<script type="text/babel">
import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';
import { withParams } from 'vuelidate/lib';
import SaveBtn from './save-btn.vue';

export default {
  name: 'hospitaledit',
  components: {
    SaveBtn,
  },
  data() {
    const iniHospital = {
      abbr: '',
      address: '',
      city: this.$store.state.settings.defaultCity,
      comment: '',
      fullName: '',
      telephones: [],
    };
    if (this.$route.params.id) { // editing existing hospital
      Object.assign(iniHospital, this.$store.state.units[this.$route.params.id]);
    }
    return {
      iniHospital,
      tempHospital: Object.assign({}, iniHospital),
      cities: [],
    };
  },
  validations: {
    tempHospital: {
      abbr: {
        required: withParams({ message: 'Введите сокращенное название' }, required),
      },
      city: {
        required: withParams({ message: 'Введите город' }, required),
      },
    },
  },
  mounted() {
    this.fetchCities();
    this.$watch('lbl', (a) => {
      document.title = a;
    }, {
      immediate: true,
    });
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    addNew() {
      return this.$route.name === 'unitNew';
    },
    lbl() {
      if (this.addNew) {
        return '*Новый объект*';
      }
      return this.iniHospital.abbr;
    },
    notChanged() {
      return _.isEqual(this.iniHospital, this.tempHospital);
    },
    telString: {
      get() {
        return this.tempHospital.telephones.join('\n');
      },
      set(newValue) {
        this.tempHospital.telephones = newValue.split('\n').map(t => t.trim());
      },
    },
  },
  methods: {
    fetchCities() {
      const self = this;
      this.$dataDB.query('utils/cities', { group: true })
        .then((result) => {
          self.cities = result.rows.map(row => ({ value: row.key, label: row.key }));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    doSave() {
      this.$v.tempHospital.$touch();
      if (this.$v.tempHospital.$invalid) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Неверный ввод',
        });
        return false;
      }
      if (this.addNew) {
        this.tempHospital.parent_id = 'root';
        const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        this.tempHospital._id = `hosp:${timestamp}${'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase()}`;
      }
      // this turn off warning
      Object.assign(this.iniHospital, this.tempHospital);
      this.$store.dispatch('saveUnit', this.tempHospital)
        .then(() => {
          this.$router.jumpBack();
        })
        .catch(() => {
          this.$store.commit('pushError', {
            error: 'Ошибка!',
            message: 'Возможно изменения не сохранены',
          });
          this.goView();
        });
    },
    goView() {
      // this turn off warning -- removed
      // Object.assign(this.iniHospital, this.tempHospital);
      this.$router.jumpBack();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/hospital-edit.vue